import { useTranslation } from 'react-i18next';
import { FacebookLoginButton } from 'react-social-login-buttons';
import { getAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-auth-react/recipe/thirdparty';

import { isSuperTokensError } from 'src/Components/Auth/ThirdPartySignInHandler/ThirdPartySignInHandler.component';

import styles from './FacebookSignInButton.module.scss';

const FacebookSignInButton = ({ compact }: { compact: boolean }) => {
  const { t } = useTranslation();
  const handleFacebookLoginClick = async () => {
    try {
      const authUrl = await getAuthorisationURLWithQueryParamsAndSetState({
        thirdPartyId: 'facebook',
        frontendRedirectURI: `${import.meta.env.VITE_PUBLIC_URL}/auth/callback`,
      });

      window.location.assign(authUrl);
    } catch (err: unknown) {
      if (isSuperTokensError(err)) {
        window.alert(err.message);
      } else {
        window.alert('Oops! Something went wrong.');
      }
    }
  };

  return (
    <FacebookLoginButton
      onClick={handleFacebookLoginClick}
      className={compact ? styles.compactButton : undefined}
    >
      {!compact && (
        <span className={styles.label}>
          {t('auth.connectWithFacebook', 'Continuer avec Facebook')}
        </span>
      )}
    </FacebookLoginButton>
  );
};

export default FacebookSignInButton;
